export default __webpack_public_path__ + "static/media/FreeFoodFrenzy_159x150.f48a39d1.png";